import * as React from 'react';
import { observer } from 'mobx-react';
import WhoIsItFor from '../../Right/WhoIsItFor';
import { selectProductLicense } from './Selection';
import Competencies from '../../Right/Competencies';
import { T } from '../../../../../../../Translations';
import LearningCollectionStore from '../../../../Store';
import { ProductLicenseResource } from '../../../../../Types';
import { emptyFragment } from '../../../../../../../EmptyFragment';
import IncludesFollowingContent from '../../Right/IncludesFollowingContent';

interface Props {
  store: LearningCollectionStore;
  activeProductLicense: ProductLicenseResource;
}

const MoreDetailsMobileView: React.FC<Props> = ({ store, activeProductLicense }) =>
  selectProductLicense(store.selectedProductLicense, activeProductLicense)
    .map(() => (
      <div className="lg:hidden mt-4 py-4 block">
        <h4 className="text-[#202532] font-semibold">
          <T kind="More details about this license" />
        </h4>
        <div className="flex flex-col">
          <WhoIsItFor productLicense={activeProductLicense} />
          <IncludesFollowingContent productLicense={activeProductLicense} />
          <Competencies productLicense={activeProductLicense} />
        </div>
      </div>
    ))
    .getOrElse(emptyFragment);

export default observer(MoreDetailsMobileView);
